<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">员工充值受理</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>
        说明：针对消费方式属于配额的员工，当配额的额度使用完成后，员工可在后台提起充值申请，经管理员审核通过后，从企业余额中为其充值（充值的额度在月底不会清零，只有配额会在月底将未使用完的额度清零回收至企业余额）
      </div>
    </div>
    <div>
      <Table :data="data" :columns="columns" />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      date: [],
      page: {
        p: 0,
        l: 10,
      },
      total: 0,
      data: [],
      columns: [
        { key: "id", title: "编号" },
        { key: "name", title: "员工名称" },
        { key: "tel", title: "手机号" },
        {
          key: "create_time",
          width: 135,
          title: "申请时间",
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { key: "money", title: "申请金额" },
        {
          key: "status",
          title: "状态",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.status === 1
                ? "已处理"
                : data.row.status === 2
                ? "已驳回"
                : "处理中"
            );
          },
        },
        { key: "note", title: "申请说明" },
        {
          title: "操作",
          key: "operate",
          render: (h, data) => {
            if (data.row.status != 0) return false;
            console.log(data.row.status);
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "success",
                  },
                  on: {
                    click: () => {
                      this.Recharge(data.row);
                    },
                  },
                },
                "确认充值"
              ),
            ]);
          },
          fixed: "right",
          width: 100,
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.GetStaffRechargeList({
        p: this.page.p,
        l: this.page.l,
      }).then((res) => {
        this.data = res.data;
        this.total = res.total;
      });
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    Recharge(data) {
      this.StaffRechargeData({
        id: data.id,
        user_id: data.user_id,
        money: data.money,
        staff_id: data.staff_id,
      }).then((res) => {
        if (res.code) {
          this.$Message.success("操作成功");
          this.page.p = 0;
          this.getData();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    ...mapActions(["GetStaffRechargeList", "StaffRechargeData"]),
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
